import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const IconPaintCanGroup: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);

  return (
    <g fill="none" {...(props.group ?? {})}>
      <path
        d="M7.20841 17.0834L2.08341 11.9584C1.94453 11.8195 1.84036 11.6667 1.77091 11.5C1.70147 11.3334 1.66675 11.1597 1.66675 10.9792C1.66675 10.7986 1.70147 10.625 1.77091 10.4584C1.84036 10.2917 1.94453 10.1389 2.08341 10L6.87508 5.22919L4.66675 3.02085L5.95841 1.66669L14.2917 10C14.4306 10.1389 14.5313 10.2917 14.5938 10.4584C14.6563 10.625 14.6876 10.7986 14.6876 10.9792C14.6876 11.1597 14.6563 11.3334 14.5938 11.5C14.5313 11.6667 14.4306 11.8195 14.2917 11.9584L9.16675 17.0834C9.02786 17.2222 8.87508 17.3264 8.70841 17.3959C8.54175 17.4653 8.36814 17.5 8.18758 17.5C8.00703 17.5 7.83341 17.4653 7.66675 17.3959C7.50008 17.3264 7.3473 17.2222 7.20841 17.0834ZM8.18758 6.54169L3.72925 11H12.6459L8.18758 6.54169ZM16.5001 17.5C16.0001 17.5 15.5765 17.3229 15.2292 16.9688C14.882 16.6146 14.7084 16.1806 14.7084 15.6667C14.7084 15.2917 14.8022 14.9375 14.9897 14.6042C15.1772 14.2709 15.389 13.9445 15.6251 13.625L16.5001 12.5L17.4167 13.625C17.639 13.9445 17.8473 14.2709 18.0417 14.6042C18.2362 14.9375 18.3334 15.2917 18.3334 15.6667C18.3334 16.1806 18.1529 16.6146 17.7917 16.9688C17.4306 17.3229 17.0001 17.5 16.5001 17.5Z"
        fill={fillColor}
      />
    </g>
  );
};

export const IconPaintCanSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      {...(props.svg ?? {})}
    >
      <IconPaintCanGroup {...props} />
    </svg>
  );
};
